<template>
  <qx-card-form title="基础信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <!-- 载重容积 -->
      <section slot="trailerLoad" slot-scope="prop">
        <el-input
          class="appendInputBox"
          v-model="prop.form.trailerLoad"
          placeholder="载重"
          :disabled="trailerLoadDisabled"
        >
          <span slot="suffix">
            <span class="unit">吨</span>
            <el-input
              class="inputAppendInput"
              v-model="otherFormData.trailerVolume"
              :clear="true"
              placeholder="容积"
            >
              <span class="unit" slot="suffix">立方</span>
            </el-input>
          </span>
        </el-input>
      </section>
      <!-- 载重容积 end -->
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import { checkVehicleNumber } from '@qx/utils/index';
import {
  getTenantTrailerRelByPlateNumber,
} from 'api/car';
export default {
  data () {
    return {
      trailerLoadDisabled: false,
      otherFormData: {
        trailerId: '',
        isAutit: '',
        tenantId: '',
        opId: '',
        channelType: '',
        updateOpId: '',
        id: '',
        relId: '',
        vehicleCode: '',
        trailerVolume: '',
      },
      baseForm: {
        // 挂车材质
        trailerMaterialOptions: [],
        // 挂车车长
        trailerLengthOptions: [],
        // 挂车种类
        vehicleClassOptions: [],
        inline: true,
        form: [
          {
            label: '车牌号码',
            value: 'trailerNumber',
            type: 'input',
            onChange: async (trailerNumber) => {
              this.checkVehiclePlateNumberCanRegister(trailerNumber);
            },
            onInput: async (trailerNumber) => {
              setTimeout(() => {
                this.checkVehiclePlateNumberCanRegister(trailerNumber);
              }, 200);
            },
          },
          {
            label: '挂车材质',
            value: 'trailerMaterial',
            type: 'select',
            default: '-1',
          },
          {
            label: '挂车车长（米）',
            value: 'trailerLength',
            type: 'select',
            default: '-1',
            allowCreate: true,
            filterable: true,
          },
          {
            label: '载重容积',
            value: 'trailerLoad',
            slot: true,
          },
          {
            label: '车辆类型',
            value: 'trailerType',
            type: 'input',
          },
          {
            label: '挂车种类',
            value: 'vehicleClass',
            type: 'select',
            default: '-1',
            onChange: () => {
              this.$emit('switchToOutTrailer', this.$refs.baseForm.getVal('vehicleClass'));
            },
          },
        ],
        rules: {
          trailerNumber: [ // 车牌号码
            { required: true, message: '请输入车牌号码', trigger: 'blur' },
            { validator: this.isVehicleNumber, trigger: 'blur' },
          ],
          trailerMaterial: [
            { required: true, message: '请选择挂车材质', trigger: 'change' },
          ],
          trailerLength: [
            { required: true, message: '请选择挂车车长', trigger: ['blur', 'change'] },
          ],
          trailerLoad: [ // 载重容积
            { required: true, message: '请输入载重', trigger: 'blur' },
            { validator: this.checkGoodsVolume, trigger: 'blur' },
          ],
          trailerType: [ // 车辆类型
            { required: true, message: '请输入车辆类型', trigger: 'blur' },
          ],
          vehicleClass: [
            { required: true, message: '请选择挂车种类', trigger: 'change' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    checkGoodsVolume (rule, value, call) {
      if (this.otherFormData.trailerVolume) {
        call();
      } else {
        call('请输入容积');
      }
    },
    setList (enums = []) {
      // 挂车材质
      this.baseForm.trailerMaterialOptions = Array.isArray(enums[0]) ? enums[0] : [];
      // 挂车车长
      this.baseForm.trailerLengthOptions = Array.isArray(enums[1]) ? enums[1] : [];
      // 挂车种类
      this.baseForm.vehicleClassOptions = Array.isArray(enums[2]) ? enums[2] : [];
    },
    // 检测车牌号码格式以及是否已在此车队注册
    async checkVehiclePlateNumberCanRegister (trailerNumber) {
      if (checkVehicleNumber(trailerNumber)) {
        await getTenantTrailerRelByPlateNumber({ trailerNumber });
      }
    },
    // 统一处理数据格式
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      this.otherFormData = {
        trailerId: '',
        isAutit: '',
        tenantId: '',
        opId: '',
        channelType: '',
        updateOpId: '',
        id: '',
        relId: '',
        vehicleCode: '',
        trailerVolume: '',
      };
      return res;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        if (!this.$route.query.id) {
          // 新增的时候不需要在 formData 里面提交这些参数
          Object.keys(this.otherFormData).forEach((item) => {
            if (item !== 'trailerVolume') {
              delete formData[item];
            }
          });
        }
      }
      console.log('base提交参数', formData);
      return formData;
    },
    async init (data = {}) {
      // 修改状态禁止修改车牌号码
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: !!this.$route.query.id,
        names: ['trailerNumber'],
      });

      this.$refs.baseForm.reset();
      if (data.trailer) {
        // 如果是详情返回的
        data.trailerNumber = data.trailer.trailerNumber || '';
        data.trailerVolume = data.trailer.trailerVolume || '';
        if (data.trailer.trailerMaterial !== undefined && data.trailer.trailerMaterial !== null) {
          data.trailerMaterial = String(data.trailer.trailerMaterial);
        }
        data.trailerLength = data.trailer.trailerLength || '-1';
        data.trailerLoad = data.trailer.trailerLoad || '';
        data.trailerVolume = data.trailer.trailerVolume || '';
        data.vinNo = data.trailer.vinNo || '';
        data.trailerType = data.trailer.trailerType;
      }
      if (data.trailerVolume) {
        this.otherFormData.trailerVolume = data.trailerVolume;
      }
      if (data.trailerRel) {
        this.setFormValFromData(this.otherFormData, data.trailerRel);
        // this.otherFormData.relId = data.trailerRel.relId;
        data.vehicleClass = String(data.trailerRel.vehicleClass) || '-1';

        this.$emit('switchToOutTrailer', String(data.trailerRel.vehicleClass));
      }
      if (data.ext) {
        this.otherFormData.id = data.ext.id;
        this.otherFormData.vehicleCode = data.ext.vehicleCode;
      }
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
.trailerNumber-register-tips {
  margin-left: 16px;
  &.yes {
    color: #13ce66;
  }
  &.no {
    color: red;
  }
}
</style>
